import { TranslationService } from "../../../../services/TranslationService";
import { useHistory } from "react-router-dom";
import { LinkWithHistory } from "../../../shared/BreadcrumbHistory";
import CompanyService from "../../../../services/CompanyService";
import FloatingPanelService from "../../../shared/FloatingPanel";
import NewScheduledTaskForm from "./add/NewScheduledTaskForm";
import ScheduledTaskTableProvider, {
  ScheduledTaskTableContextValues
} from "./ScheduledTaskTableProvider";
import { useContext } from "react";
import TableContext from "../../TableContext";

const ScheduleTaskTableItem = (props: any) => {
  const days = [
    TranslationService.translate.Sunday,
    TranslationService.translate.Monday,
    TranslationService.translate.Tuesday,
    TranslationService.translate.Wednesday,
    TranslationService.translate.Thursday,
    TranslationService.translate.Friday,
    TranslationService.translate.Saturday
  ];
  const history = useHistory();
  const tableContext = useContext(TableContext);
  const { reload } = tableContext as ScheduledTaskTableContextValues;

  const getPeriod = (repeatPeriod: number, frequency?: number): string => {
    switch (repeatPeriod) {
      case 0:
        return TranslationService.translate.Daily;
      case 1:
        return `${TranslationService.translate.Weekly} ${TranslationService.translate.Every.toLocaleLowerCase()} ${days[(frequency ?? 1) - 1]}`;
      case 2:
        return `${TranslationService.translate.Monthly} ${TranslationService.translate.Every.toLocaleLowerCase()} ${frequency}`;
      default:
        return "";
    }
  };

  const responsibleUser = CompanyService.getUsers()?.find(
    (x) => x.Id === props.data.ResponsibleUserID?.toString()
  )?.Value;

  return (
    <>
      <tr
        key={props.data.ScheduledTaskID}
        role="button"
        onClick={() =>
          FloatingPanelService.showPanel({
            children: (
              <ScheduledTaskTableProvider userId={undefined}>
                <NewScheduledTaskForm
                  scheduleTask={props.data}
                  onNewTask={reload}
                  readonly={!CompanyService.canDoAny(["edittask", "newtask"])}
                />
              </ScheduledTaskTableProvider>
            ),
            title: TranslationService.translate.NewScheduledTask,
            width: 700,
            height: 650,
            position: "center"
          })
        }
        style={{ cursor: "pointer" }}
      >
        <td>
          {/* cliente */}
          <span
            className={" " + (props.data.groupCount > 0 ? " fw-bolder" : "")}
          >
            <LinkWithHistory
              to={() =>
                history.push(
                  `/${TranslationService.currentLanguage}/client/details?id=${props.data.PersonID}`
                )
              }
            >
              {props.data?.Person?.Name}
            </LinkWithHistory>
          </span>
        </td>
        <td className="text-start">
          {/* Responsable */}
          <span className="w-md">{responsibleUser}</span>
        </td>
        <td className="text-start">
          <span className="w-md">
            {/* vencimiento */}
            {`${props.data?.dueDays} ${TranslationService.translate.Days}`}
          </span>
        </td>
        <td className="text-start">
          {/* cuando */}
          <span className="w-md">
            {getPeriod(props.data?.RepeatPeriod, props.data?.RepeatFrequency)}
          </span>
        </td>
        <td className="text-start">
          {/* descripcion */}
          <span className="w-md"> {props.data?.Description}</span>
        </td>
      </tr>
    </>
  );
};

export default ScheduleTaskTableItem;
